import React, { useEffect } from 'react';
import Store, { StoreProvider, useStore } from 'stores/Store';
import { TealiumProvider } from './Tealium';
import { PearlRoutes } from './routes/PearlRoutes';
import { RealtimeProvider } from 'contexts/RealtimeContext';
import { PearlThemeProvider } from 'dbi-pearl-ui-kit';
import { PearlModalProvider, PearlToastProvider } from './framework';
import { GlobalMessageListeners } from './framework/components/GlobalMessageListeners';
import { PearlSearchProvider } from './event-user/contexts/PearlSearchContext';
import { PageTitle } from './vendor/components/PageTitle';
import { createTheme } from '@mui/material/styles';
import { ApiLoader } from 'shared/components/ApiLoader/ApiLoader';
import { StatusBar } from 'vendor/components/StatusBar/StatusBar';
import { ImpersonationBanner } from './shared/components/Impersonation/ImpersonationBanner';
import { ApiLoadingProvider } from 'framework/lib/apis/ApiLoaderContext';
import { TokenService } from 'lib/apis/TokenService';
import { PostHogProvider } from 'contexts/PostHogContext';

export default function App() {
    const store = new Store();
    const muiTheme = createTheme();
    const userDetails = useStore() || {};
    const { authUser } = userDetails;
    const tokenService = TokenService();

    useEffect(() => {
        const baseUrl = process.env.REACT_APP_BASE_URL;

        const loadPypestream = async () => {
            const token = await tokenService?.getOrRefreshAccessToken();

            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;

            if (baseUrl === 'https://pearl.davidsbridal.com') {
                window.pypestreamConfig = {
                    APP_ID: 'cfa6df86-aa87-4dda-9877-815aea0b560b',
                    first_name: authUser?.FirstName || '',
                    last_name: authUser?.LastName || '',
                    phone: authUser?.PhoneNumber || '',
                    email: authUser?.Email || '',
                    screen_name: 'Screen 1',
                    token: token || '',
                    passthrough: '',
                    language: 'en',
                    play_chime: false,
                };
                script.src = 'https://web.pypestream.com/launcher.js?ts=' + Date.now();
            } else {
                window.pypestreamConfig = {
                    APP_ID: 'a788feaf-23a7-4a13-89dc-77469a0e4c5e',
                    passthrough: '',
                    language: 'en',
                };
                script.src = 'https://web-sandbox.pypestream.com/launcher.js?ts=' + Date.now();
            }

            document.body.appendChild(script);
        };

        loadPypestream();
    }, [authUser]);

    setTimeout(() => {
        window.prerenderReady = true;
    }, 5000);

    return (
        <RealtimeProvider store={store}>
            <PearlThemeProvider theme={muiTheme}>
                <ApiLoadingProvider>
                    <ApiLoader />
                    <PearlToastProvider>
                        <StoreProvider store={store}>
                            <PostHogProvider>
                                <ImpersonationBanner>
                                    <PearlModalProvider>
                                        <GlobalMessageListeners />
                                        <PearlSearchProvider>
                                            <PageTitle />
                                            <StatusBar />
                                            <TealiumProvider>
                                                <PearlRoutes store={store} />
                                            </TealiumProvider>
                                        </PearlSearchProvider>
                                    </PearlModalProvider>
                                </ImpersonationBanner>
                            </PostHogProvider>
                        </StoreProvider>
                    </PearlToastProvider>
                </ApiLoadingProvider>
            </PearlThemeProvider>
        </RealtimeProvider>
    );
}
